import React, { useState, useEffect, useRef } from "react";

import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { InputGroup, Button, FormControl, Modal, Col, Row } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import ApiContact from "../../../core/api/api.contact";
import { useForm } from "react-hook-form";
import DataGrid from "./DataGrid";
import GlobalFormControl from "../_Components/GlobalFormControl";

export const Contact = () => {
  // =============== usestats ========================================================================
  const [listData, setListData] = useState({}); // datas that send to child component
  const [isActiv, setIsActiv] = useState(false);
  const [id, setId] = useState(0); // the id that get from child component for update
  const [isActiv2, setIsActiv2] = useState(false);
  const [show, setShow] = useState(false); //stat for show or unshow the modal 1
  const [showEdit, setShowEdit] = useState(false); //stat for show or unshow the modal 2
  const [shows, setShows] = useState(""); //state for search  and run useEffect functions
  const [search, setSearch] = useState(""); //state for search
  const [singelDataUpdat, setSingelDataUpdat] = useState({}); //a data that choose for update and edit

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = useForm({}); //use form  for modal  1

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    reset: reset2,
  } = useForm({}); //useform  for modal  2

  // =====================================================================================================================
  const handleClose = () => {
    setShow(false);
    reset();
  };

  const handleShow = () => setShow(true);

  const handleClose2 = () => {
    setShowEdit(false);
    reset2();
  };
  // ====================get datas from api by  ussEffect  =================================================================================
  useEffect(() => {
    (async () => {
      try {
        const data = await ApiContact.getAll({ pageSize: 100, pageNumber: 1, globalSearch: shows });
        setListData(data.data);
        console.log(data);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();

    return () => { };
  }, [shows, show, showEdit]);
  // ========================== save data ===================================================================================
  // save data
  const handleSave = (data) => {
    (async () => {
      const datas = {
        name: data.type,
        dispalyName: data.displayname,
        value: data.disvalue,
        type: 1,
        status: isActiv,
      };

      const response = await ApiContact.create(datas);
      setShow(false);
      reset();
      setShows("");
      setShow(true);
      setShow(false);
    })();
  };
  // =================================== updata data =========================================================================
  // update
  const handleUpdate = (datas) => {
    (async () => {
      const data = {
        id: id,
        name: datas.type2 ? datas.type2 : singelDataUpdat.name,
        dispalyName: datas.displayname2 ? datas.displayname2 : singelDataUpdat.dispalyName,
        value: datas.disvalue2 ? datas.disvalue2 : singelDataUpdat.value,
        type: 1,
        status: isActiv2,
      };
      console.log(data);
      const response = await ApiContact.update(id, data);
      reset2();
      setShowEdit(false);
      setShowEdit(true);
      setShowEdit(false);
      setShows("");
      console.log(response, "response update", datas.displayname2);
    })();
  };
  // ================================ get id from child componDataGrident =========================================================
  // get an object from child component for update
  const callBack = (index) => {
    setId(parseInt(index.id)); //get id
    setSingelDataUpdat(index); //object => one data
    setIsActiv2(index.status); // is it active or not ?
    setShowEdit(true); // show modal 2
  };
  // =================================== HTML ==================================================================
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت تماس با ما</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست تماس ها</span>
          </h3>
          <div className="card-toolbar">
            <Button variant="primary" onClick={handleShow}>
              <AddCircle className="mr-1" />
              ایجاد اطلاعات جدید
            </Button>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="border-top pt-3">
            <InputGroup className="mb-3">
              <GlobalFormControl
                aria-describedby="basic-addon1"
                placeholder="جستجو ..."
                name="globalsearch"
                onChange={(event) => setShows(event.target.value)}
              />

              <Button variant="secondary" type="button">
                <SearchIcon />
              </Button>
            </InputGroup>
          </div>

          {/* table */}
          <Col xs="12" className="tb-reponsive px-0">
            <DataGrid data={listData} />
          </Col>
        </div>

        {/* ======================================================================================================================= */}
        {/* Start Modal */}

        <Modal centered size="md" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title> ایجاد اطلاعات جدید </Modal.Title>
          </Modal.Header>

          <form noValidate autoComplete="off" onSubmit={handleSubmit(handleSave)}>
            <Modal.Body>
              <Row>
                <Col xs="12">
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="نوع"
                    className="w-100"
                    variant="outlined"
                    size="small"
                    name="keyname"
                    {...register("type", { required: true })}
                  >
                    <MenuItem value="تلفن" key="1">
                      تلفن
                    </MenuItem>
                    <MenuItem value="تلفن اصلی" key="2">
                      تلفن اصلی
                    </MenuItem>
                    <MenuItem value="ادرس" key="3">
                      آدرس
                    </MenuItem>
                    <MenuItem value="ایمیل" key="4">
                      ایمیل
                    </MenuItem>
                  </TextField>
                </Col>

                <Col xs="12">{errors.type && <span className="text-danger"> لطفا نوع را مشخص کنید .</span>}</Col>
                <Col xs="12">
                  <TextField
                    required
                    label="عنوان"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    name="keydisplayname"
                    {...register("displayname", { required: true })}
                  />
                </Col>
                <Col xs="12">
                  {errors.displayname && <span className="text-danger"> لطفا عنوان را وارد کنید .</span>}
                </Col>
                <Col xs="12">
                  <TextField
                    required
                    label="مقدار"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    name="keydisvalue"
                    {...register("disvalue", { required: true })}
                  />
                </Col>
                <Col xs="12">{errors.disvalue && <span className="text-danger"> لطفا مقدار را وارد کنید .</span>}</Col>
                <Col xs="12">
                  <FormControlLabel
                    control={
                      <Checkbox color="primary" checked={isActiv} name="check" onChange={() => setIsActiv(!isActiv)} />
                    }
                    label="فعال"
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" variant="success">
                <SaveIcon /> ذخیره
              </Button>
              <Button variant="danger" onClick={handleClose} type="button">
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </Modal>

        {/* ============= Modal 2 for edit and update  data =================================================================== */}
        <Modal centered size="md" show={showEdit} onHide={handleClose2}>
          <Modal.Header closeButton>
            <Modal.Title>ویرایش اطلاعات </Modal.Title>
          </Modal.Header>

          <form noValidate autoComplete="off" onSubmit={handleSubmit2(handleUpdate)}>
            <Modal.Body>
              <Row>
                <Col xs="12">
                  <TextField
                    required
                    select
                    label="نوع"
                    className="w-100"
                    variant="outlined"
                    size="small"
                    placeholder={singelDataUpdat.name}
                    defaultValue={singelDataUpdat.name}
                    name="keynames"
                    {...register2("type2", { required: false })}
                  >
                    <MenuItem value="تلفن" key="1">
                      تلفن
                    </MenuItem>
                    <MenuItem value="تلفن اصلی" key="2">
                      تلفن اصلی
                    </MenuItem>
                    <MenuItem value="ادرس" key="3">
                      آدرس
                    </MenuItem>
                    <MenuItem value="ایمیل" key="4">
                      ایمیل
                    </MenuItem>
                  </TextField>
                </Col>
                <Col xs="12">{errors2.type2 && <span className="text-danger"> لطفا نوع را مشخص کنید .</span>}</Col>
                <Col xs="12">
                  <TextField
                    required
                    label="عنوان"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    name="keydisplaynames"
                    defaultValue={singelDataUpdat.dispalyName}
                    {...register2("displayname2", { required: false })}
                  />
                </Col>
                <Col xs="12">
                  {errors2.displayname2 && <span className="text-danger"> این قسمت ویرایش نشده .</span>}
                </Col>

                <Col xs="12">
                  <TextField
                    required
                    label="مقدار"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    name="keydisvalues"
                    defaultValue={singelDataUpdat.value}
                    {...register2("disvalue2", { required: false })}
                  />
                </Col>
                <Col xs="12">{errors2.disvalue2 && <span className="text-danger"> این قسمت ویرایش نشده .</span>}</Col>

                <Col xs="12">
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={isActiv2}
                        name="check"
                        onChange={() => setIsActiv2(!isActiv2)}
                      />
                    }
                    label="فعال"
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" variant="success">
                <SaveIcon /> ذخیره
              </Button>
              <Button variant="danger" type="button" onClick={handleClose2}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
};
